import { render, staticRenderFns } from "./ClientTableHeader.vue?vue&type=template&id=73f766bc&"
import script from "./ClientTableHeader.vue?vue&type=script&lang=ts&"
export * from "./ClientTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports